import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";
import { PayUProperties, usePayUProperties } from "./PayUProperties";

import { DraftPayUButtonComponent } from "./DraftPayUButtonComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { PayUButton } from ".//PayUButton";
import { Registry } from "../../../../base/register";

export const PayUButtonComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = usePayUProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) return <></>

    return (
        <PayUButton {...properties}
            className={className}>
            {children}
        </PayUButton>
    )
}

Registry.addControl({
    id: "73304858-d24c-4d01-ba38-5024962978ee",
    name: "PayU Button",
    type: ControlType.PayUButton,
    properties: PayUProperties,
    component: PayUButtonComponent,
    draftComponent: DraftPayUButtonComponent
})
